<template>
  <b-row>
    <b-col cols="12" class="mt-3">
      <b-card header-class="custom-header-bg">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left mt-1">
            <span class="mb-0 h3 ml-2">首頁推薦</span>
          </div>
          <b-button variant="light" class="border float-right" @click="addFavorBlock">新增推薦區塊</b-button>
        </template>
        <div v-if="busy" class="text-center text-primary">
          <b-spinner label="Spinning"></b-spinner>
        </div>
        <b-jumbotron v-else-if="isEmpty" header="尚未新增推薦區塊" lead="請點選右上角以新增區塊。"/>
        <vue-draggable v-else v-model="list" tag="b-row" group="top" @end="onSubmit" handle=".drag-handle">
          <b-col md="3" cols="12" v-for="(block, idx) in list" :key="block.id" class="mt-2">
            <b-form v-if="block.isEditMode" @submit.prevent="onSubmit(block)" class="p-3 border text-right">
              <b-form-group :id="`block-name-group-${idx}`" :label-for="`block-name-input-${idx}`" :state="Boolean(block.name)" class=" text-left">
                <template slot="label">
                  <span class="text-danger">*</span>推薦區塊名稱：
                </template>
                <b-form-input :id="`block-name-input-${idx}`" v-model="block.name" required :state="Boolean(block.name)"></b-form-input>
              </b-form-group>
              <b-button variant="secondary" size="sm" v-if="!block.isNew" @click="setEditMode(block, false)" class="mr-1">取消</b-button>
              <b-button variant="danger" size="sm" @click="deleteBlock(block)" class="mr-1">刪除</b-button>
              <b-button variant="primary" size="sm" type="submit">儲存</b-button>
            </b-form>
            <b-card v-else header-bg-variant="dark" header-text-variant="light" header-class="drag-handle">
              <template v-slot:header>
                <div class="float-left">
                  <span class="mb-0 h4 ml-2">{{idx+1}} {{block.name}}</span>
                </div>
                <b-button class="border float-right" size="sm" @click="setEditMode(block, true)">
                  <font-awesome-icon icon="ellipsis-h" class="text-white"/>
                </b-button>
              </template>
              <vue-draggable v-model="block.items" group="items" tag="b-list-group" draggable=".items" @end="onSubmitItems(block)" handle=".drag-handle">
                <b-list-group-item href="#" v-for="(item, idx2) in block.items" :key="`${item.id}-${idx2}`" @click="setEditMode(item, true)" class="items">
                  <b-row v-if="item.isEditMode">
                    <b-col cols="2" class="mt-2 pr-0">
                      <label :for="`item-name-input-${item.id}`">{{idx+1}}-{{idx2+1}}</label>
                    </b-col>
                    <b-col class="pl-0">
                      <model-list-select v-model="item.editCatalog" :list="itemSearchResult" @searchchange="findCatalogItem" option-value="id" option-text="name" placeholder="輸入名稱搜尋"></model-list-select>
                      <!--b-dropdown>
                        <template v-slot:button-content>
                          <b-form-input @keyup="findCatalogItem"></b-form-input>
                        </template>
                        <b-dropdown-item v-for="item in itemSearchResult" :key="item.id">{{item.text}}</b-dropdown-item>
                      </b-dropdown-->
                    </b-col>
                    <b-col cols="12">
                      <div @click.stop class="float-right mt-1">
                        <b-button variant="secondary" v-if="!item.isNew" @click="setEditMode(item, false)" size="sm" class="mr-1">取消</b-button>
                        <b-button variant="danger" @click="deleteItem(block, item)" size="sm" class="mr-1">刪除</b-button>
                        <b-button variant="primary" @click="onSubmitItems(block)" size="sm">儲存</b-button>
                      </div>
                    </b-col>
                  </b-row>
                  <div v-else class="drag-handle">{{idx+1}}-{{idx2+1}} {{item.name}}</div>
                </b-list-group-item>
                <b-list-group-item href="#" @click="addBlockItem(block)">
                  <font-awesome-icon icon="plus" class="mr-3"/>新增商品
                </b-list-group-item>
              </vue-draggable>
            </b-card>
          </b-col>
        </vue-draggable>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import QueryString from 'querystring'
import { ModelListSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import VueDraggable from 'vuedraggable'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faEllipsisH,
  faPlus
} from '@fortawesome/free-solid-svg-icons'
library.add(faEllipsisH, faPlus)
export default {
  name: 'homeset-favors',
  components: {
    VueDraggable,
    ModelListSelect
  },
  data () {
    return {
      busy: false,
      list: [],
      inEditModeItem: null,
      itemSearchResult: [],
      itemSearchBusyState: false
    }
  },
  computed: {
    isEmpty () {
      return Boolean(!this.list.length)
    }
  },
  methods: {
    async start () {
      if (this.busy) return
      this.busy = true
      try {
        const { data } = await this.$api.getFavor()
        data.forEach(block => {
          block.isItem = false
          block.isEditMode = false
          block.items.forEach(item => {
            item.isItem = true
            item.isEditMode = false
          })
        })
        this.list = data
      } catch (err) {
        console.log(err)
      }
      this.busy = false
    },
    addFavorBlock () {
      const item = {
        id: Date.now(),
        name: '',
        isNew: true,
        isEditMode: true
      }
      this.list.push(item)
      this.setEditMode(item, true)
    },
    addBlockItem (block) {
      const item = {
        id: Date.now(),
        name: '',
        isItem: true,
        isNew: true,
        isEditMode: true
      }
      block.items.push(item)
      this.setEditMode(item, true)
    },
    setEditMode (tar, bool) {
      if (bool) {
        if (tar.isItem) {
          this.$set(tar, 'editCatalog', {id: tar.id, name: tar.name})
        } else {
          this.$set(tar, 'copyName', tar.name)
        }
        this.inEditModeItem = tar
      } else {
        if (tar.isItem) {
          const edit = tar.editCatalog
          this.$set(tar, 'id', edit.id)
          this.$set(tar, 'name', edit.name)
        } else {
          this.$set(tar, 'name', tar.copyName)
        }
      }
      this.$set(tar, 'isEditMode', bool)
    },
    async deleteBlock (block) {
      if (this.busy) return
      this.busy = true
      const { id, isNew } = block
      try {
        if (!isNew) {
          await this.$api.delFavor(id)
        }
        this.list = this.list.filter(item => item !== block)
        this.busy = false
      } catch (err) {
        console.log(err)
      }
    },
    deleteItem (block, tar) {
      const data = block.items.filter(item => item !== tar)
      this.$set(block, 'items', data)
      this.$nextTick(() => this.onSubmitItems(block))
    },
    async onSubmit (block) {
      if (this.busy) return
      this.busy = true
      // sort event may emit by draggable
      const isSort = !this.list.find(item => item === block)
      const targets = isSort ? this.list : [block]
      const wait = targets.map(async (block, sort) => {
        const { id, name, isNew } = block
        const data = { name }
        if (isSort) {
          data.sort = sort
        }
        if (id && !isNew) {
          return this.$api.putFavor(data, id)
        } else {
          return this.$api.postFavor(data)
        }
      })
      try {
        await Promise.all(wait)
        this.busy = false
        this.start()
      } catch (err) {
        console.log(err)
      }
    },
    async onSubmitItems (block) {
      const { id, items } = block
      // leave edit mode
      items.forEach(item => {
        if (item.isEditMode) this.setEditMode(item, false)
      })
      const contents = items.filter(item => Boolean(item.id)).map(item => item.id)
      try {
        await this.$api.putFavorItems({ contents }, id)
        const data = items.filter(item => contents.indexOf(item.id) !== -1)
        data.forEach(item => item.isNew = false)
        this.$set(block, 'items', data)
      } catch (err) {
        console.log(err)
      }
    },
    findCatalogItem (str) {
      if (!str) return
      if (this.itemSearchBusyState) {
        clearTimeout(this.itemSearchBusyState)
      }
      this.itemSearchBusyState = setTimeout(async () => {
        try {
          const query = `?${QueryString.stringify({ name: str })}`
          const { data: { catalogs } } = await this.$api.getProdParam(query)
          this.itemSearchResult = catalogs.map(item => {
            const { id, name } = item
            return { id, name }
          })
        } catch (err) {
          console.log(err)
        }
        this.itemSearchBusyState = false
      }, 1000)
    }
  },
  watch: {
    inEditModeItem (item, oldOne) {
      if (oldOne) {
        this.setEditMode(oldOne, false)
      }
    }
  },
  mounted () {
    this.start()
  }
}
</script>